import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import "./css/ThemeMenu.css";
import { Col, Container, Row, Spinner } from "reactstrap";
// import FoodMenuService from "../../../Services/QRCodeServices/CustomerService/FoodMenuService";
// import { Theme7ItemDetail } from "./Theme7ItemDetail";

export const ThemeMenu1 = ({
  orgInfo,
  orgData,
  isVideoPlaying,
  setIsVideoPlaying,
}) => {
  // Split categories roughly into two halves
  const categories = Object.entries(orgInfo);
  const midIndex = Math.ceil(categories.length / 2);
  const leftCategories = categories.slice(0, midIndex);
  const rightCategories = categories.slice(midIndex);

  return (
    <Container fluid className="theme-seven-menu-wrapper">
      {/* Header */}
      <Row className=" text-brown border-brown ">
        <Col
          xs={12}
          md={4}
          className="text-end p-4 d-none d-lg-block d-md-block"
          style={{ borderRight: "2px dashed #7B3F00" }}
        >
          <p className="mb-0">{orgData?.address1}</p>
        </Col>
        <Col xs={12} md={4} className="text-center p-4">
          <h1 className="fw-bold display-6 text-uppercase">{orgData?.name}</h1>
          <p className="mb-2 d-block d-lg-none d-md-none text-center">
            {orgData?.address1}
          </p>
          <h3 className="fw-bold  text-uppercase">Menu</h3>
        </Col>

        <Col
          xs={12}
          md={4}
          className="text-start p-4 d-none d-md-block d-lg-block"
          style={{ borderLeft: "2px dashed #7B3F00" }}
        >
          <p className="mb-1">Open from 8am - 8pm</p>
          <p className="text-muted mb-1">{orgData?.email}</p>
          <p className="text-muted mb-0">{orgData?.tel}</p>
        </Col>
      </Row>

      {/* Two-column menu */}
      <Row className="menu-body">
        {/* Left side */}
        <Col md={6} className="menu-column left-menu pe-md-5">
          {leftCategories.map(([category, items]) => (
            <div key={category} className="menu-section mb-5">
              <h2 className="category-title text-center">{category}</h2>
              {items.map((item) => {
                const discountedPrice = item.discountDetail?.discountPercentage
                  ? item.price *
                    (1 - item.discountDetail.discountPercentage / 100)
                  : null;
                return (
                  <div key={item.id} className="menu-item-row">
                    <div className="item-name">{item.name}</div>
                    <div className="item-dots"></div>
                    <div className="item-price">
                      {discountedPrice ? (
                        <>
                          <span className="strikethrough">
                            Rs {item.price.toFixed(2)}
                          </span>{" "}
                          <span className="discounted-price">
                            Rs {discountedPrice.toFixed(2)}
                          </span>
                        </>
                      ) : (
                        <span className="price">
                          Rs {item.price.toFixed(2)}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </Col>

        {/* Right side with vertical dotted border */}
        <Col md={6} className="menu-column right-menu ps-md-5">
          {rightCategories.map(([category, items]) => (
            <div key={category} className="menu-section mb-5">
              <h2 className="category-title text-center">{category}</h2>
              {items.map((item) => {
                const discountedPrice = item.discountDetail?.discountPercentage
                  ? item.price *
                    (1 - item.discountDetail.discountPercentage / 100)
                  : null;
                return (
                  <div key={item.id} className="menu-item-row">
                    <div className="item-name">{item.name}</div>
                    <div className="item-dots"></div>
                    <div className="item-price">
                      {discountedPrice ? (
                        <>
                          <span className="strikethrough">
                            Rs {item.price.toFixed(2)}
                          </span>{" "}
                          <span className="discounted-price">
                            Rs {discountedPrice.toFixed(2)}
                          </span>
                        </>
                      ) : (
                        <span className="price">
                          Rs {item.price.toFixed(2)}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};
